export const INITIALIZE_SEARCH = 'petdata/INITIALIZE_SEARCH';

export const TOGGLE_FILTER_DISPLAY = 'petdata/TOGGLE_FILTER_DISPLAY';

export const SEARCH_INPUT_BLUR = 'petdata/SEARCH_INPUT_BLUR';
export const SEARCH_INPUT_FOCUS = 'petdata/SEARCH_INPUT_FOCUS';
export const SEARCH_INPUT_DIRTY = 'petdata/SEARCH_INPUT_DIRTY';


/** WEBPACK FOOTER **
 ** ./src/modules/search/actionTypes.js
 **/